import { cn } from '@/lib/utils';
import type { Confidence } from '@/types';

/** 3-tier confidence band — never false precision (brief §6.4). */
export function ConfidenceBand({ level, className }: { level: Confidence; className?: string }) {
  const filled = level === 'high' ? 3 : level === 'medium' ? 2 : 1;
  return (
    <div className={cn('flex items-center gap-1.5', className)} title={`${level} confidence`}>
      <div className="flex items-end gap-0.5" aria-hidden>
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className={cn(
              'w-1 rounded-full',
              i === 0 ? 'h-2' : i === 1 ? 'h-2.5' : 'h-3',
              i < filled ? 'bg-ai' : 'bg-border-default',
            )}
          />
        ))}
      </div>
      <span className="text-[11px] font-medium capitalize text-text-secondary">{level}</span>
    </div>
  );
}
